import React from "react";

export default function ContentSection({ 
  title, 
  description, 
  titleAnimated, 
  descriptionAnimated 
}) {
  return (
    <div className="content-section">
      <TitleSection 
        title={title}
        animated={titleAnimated}
      />
      
      <DescriptionSection 
        description={description}
        animated={descriptionAnimated}
      />

      <InteractiveElements animated={descriptionAnimated} />
    </div>
  );
}

function TitleSection({ title, animated }) {
  return (
    <div className={`title-container ${animated ? 'slide-in-right' : ''}`}>
      <h2 className="info-title">{title}</h2>
      <div className="title-underline"></div>
    </div>
  );
}

function DescriptionSection({ description, animated }) {
  return (
    <div className={`description-container ${animated ? 'slide-in-right' : ''}`}>
      <h2 className="info-description">{description}</h2>
      {/* <div className="content-accent"></div> */}
    </div>
  );
}

function InteractiveElements({ animated }) {
  return (
    <div className={`interactive-elements ${animated ? 'slide-in-right' : ''}`}>
      <div className="pulse-indicator"></div>
      <div className="gradient-line"></div>
    </div>
  );
}